<div class="row">
  <div class="col-8 offset-2">
    <div class="d-flex justify-content-center edit-form">
      <form class="example-form d-flex flex-column" [formGroup]="editForm">
        <div class="cms-container">
          <label>Chọn quỹ   <span class="required">*</span></label>
          <div class="form-group">
            <dropdown
              formControlName="productId"
              [field]="'shortName'"
              [list]="funds"
              [title]="'Vui lòng chọn sản phẩm quỹ'"
            >
            </dropdown>
          </div>
          <app-error-text [isDisplay]="isSaved && !editForm.get('productId').value" 
          [message]="'Chưa chọn quỹ'">
          </app-error-text>
        </div>
        <div class="cms-container">
          <label>Số tiền chia cổ tức <span class="required">*</span></label>
          <input-number  [isDecimal]="true" formControlName="dividendAmt">
          </input-number>
          <app-error-text [isDisplay]="isSaved && errors.amount" 
          [message]="'Chưa nhập số tiền'">
          </app-error-text>
        </div>
        <div class="cms-container">
          <label>Ngày chia cổ tức <span class="required">*</span></label>
          <input-date id="inputDatepicker" formControlName="dividendDate" >
          </input-date>
          <app-error-text [isDisplay]="isSaved && editForm.get('dividendDate')?.errors?.required" 
          [message]="'Ngày không đúng định dạng dd/mm/yyyy'">
          </app-error-text>
        </div>
        <div class="cms-container">
          <label>Ngày thanh toán</label>
          <input-date id="inputDatepicker1" formControlName="paymentDate" >
          </input-date>
        </div>
        <div class="cms-container">
          <label>Ngày giao dịch không hưởng quyền</label>
          <input-date id="inputDatepicker2" formControlName="exDividendDate">
          </input-date>
        </div>
       
        <div class="d-flex justify-content-end">
          <button class="btn btn-primary btn-save waves-effect waves-light" (click)="save()"
          [disabled]="editForm.invalid">Lưu</button>
        </div>
      </form>
    </div>
  </div>
</div>